module.exports = __webpack_public_path__ + "static/media/like.454539ea.svg";